import { EventMember, EventPriceCategory } from '../shared/types'

const getPriceForEventMember = (eventMember: EventMember, eventPriceCategories?: EventPriceCategory[]) => {
  let price = 0
  eventMember.eventPriceCategories.map(category => {
    const categoryPriceElement = eventPriceCategories?.find(elem => elem.id === category.eventPriceCategoryId)
    price += categoryPriceElement && categoryPriceElement.price ? (categoryPriceElement.price * category.quantity) : 0
  })
  return price
}

export default getPriceForEventMember
